module.exports = __webpack_public_path__ + "static/media/high.c3803704.svg";